import React from 'react';
import Header from "./Header";
import Footer from "./Footer";
import {Box} from "@chakra-ui/react";

const Layout = ({children}) => {
    return (
        <Box className='layout'>
            <Header/>
            <div className="main">
                {children}
            </div>
            <Footer/>
        </Box>
    );
};

export default Layout;